import { Chip, Tooltip } from "@dust-tt/sparkle";
import { useLingui } from "@lingui/react/macro";

const FRAMES_BETA_URL =
  "https://app.dust.tt/share/frame/c5d83f0e-4825-4c6f-b33a-6841b1490d19";

/**
 * Marks a Frame that declares functions as beta, wherever Dust renders the chrome around it.
 * Links out to the Frame documenting the beta, in a new tab so the Frame being viewed stays open.
 */
export function FrameBetaChip() {
  const { t } = useLingui();

  // Laufwerk AI: Beta-Hinweis ohne Link auf Dusts Erklär-Frame (FRAMES_BETA_URL, Tooltip ungenutzt)
  return (
    <span className="inline-flex shrink-0 items-center">
      <Chip size="mini" label={t`Beta`} />
    </span>
  );
}
